import { defineMessage } from '../../../../../services/localization';

export const messages = {
    xeroOrg: defineMessage('xero_organisation'),
    qboOrg: defineMessage('quickbooks_online_organisation'),
};
